import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

import { DevelopmentService } from "@service/development.service";
import { PlanningService } from "@service/planning.service";

import { SearchString } from "@model/SearchString";
import { Source } from "@model/Source";

@Component({
  selector: "app-modal-add-base-string",
  templateUrl: "./modal-add-base-string.component.html",
  styleUrls: ["./modal-add-base-string.component.scss"],
})
export class ModalAddBaseStringComponent implements OnInit {
  @Input() public string_base: string;
  @Input() public protocolFonts: Array<Source>;
  @Input() public searchString: SearchString = {} as SearchString;
  @Input() public projectId: number;

  public stringForm: FormGroup;
  public submitted: boolean = false;
  public showImportString = true;
  projectKeywords: string = "";

  constructor(
    private developmentService: DevelopmentService,
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private planningService: PlanningService
  ) {}

  ngOnInit() {
    if (!this.searchString.string_base) {
      this.searchString.protocol_font_id = null;
      this.searchString.string_base = "";
      this.searchString.ini_period = "";
      this.searchString.end_period = "";
      this.searchString.doc_types = "";
      this.searchString.crawlers = [
        { display: "TÍTULO", value: "TÍTULO" },
        { display: "RESUMO", value: "RESUMO" },
        { display: "PALAVRAS-CHAVE", value: "PALAVRAS-CHAVE" },
      ];
      this.searchString.in_checklist = true;
    }

    this.planningService.getProtocol(this.projectId).subscribe((res) => {
      JSON.parse(res.keywords).forEach((element) => {
        this.projectKeywords += ` ${element.value}`;
      });
    });
    this.initForm();
  }

  initForm() {
    const crawlersDefaultValue =
      this.searchString.crawlers &&
      this.searchString.crawlers.reduce(
        (accumulator, currentValue, index, arr) =>
          accumulator + currentValue.display + (index < arr.length ? "\n" : ""),
        ""
      );
    this.stringForm = this.formBuilder.group({
      font: [this.searchString.protocol_font_id, [Validators.required]],
      string_base: [this.searchString.string_base, [Validators.required]],
      ini_period: [this.searchString.ini_period, []],
      end_period: [this.searchString.end_period, []],
      doc_types: [this.searchString.doc_types, []],
      crawlers: [crawlersDefaultValue, []],
      in_checklist: [this.searchString.in_checklist, []],
    });
  }

  public save(): void {
    this.submitted = true;

    if (this.stringForm.invalid) {
      return;
    }

    const formData: any = this.stringForm.value;

    this.searchString.protocol_font_id = formData.font;
    this.searchString.string_base = formData.string_base;
    this.searchString.ini_period = formData.ini_period;
    this.searchString.end_period = formData.end_period;
    this.searchString.doc_types = formData.doc_types;

    const values = formData.crawlers.split("\n");

    if (values.length > 0) {
      this.searchString.crawlers = values.filter((v) => v.length > 0);
      this.searchString.crawlers = this.searchString.crawlers.map((v) => ({
        display: v,
        value: v,
      }));
    }
    // this.searchString.crawlers = formData.crawlers;
    this.searchString.in_checklist = formData.in_checklist;

    if (this.hasSearchString()) {
      this.developmentService
        .updateSearchString(this.searchString.id, this.searchString)
        .subscribe((searchString: SearchString) => {
          this.activeModal.close(searchString);
        });
    } else {
      this.developmentService
        .storeSearchString(this.searchString)
        .subscribe((searchString: SearchString) => {
          this.activeModal.close(searchString);
        });
    }
  }

  public HiddenImportString() {
    if (
      this.stringForm.value.string_base ||
      this.stringForm.value.string_base != ""
    ) {
      this.showImportString = false;
    } else {
      this.showImportString = true;
    }
  }

  hasSearchString() {
    return this.searchString.id;
  }

  public importBaseString(): void {
    if (this.string_base) {
      this.stringForm.get("string_base").setValue(this.string_base);
      return;
    }
    this.stringForm.get("string_base").setValue(this.projectKeywords);
  }
}
